import {ComboFiltersController} from 'plugins/modules/filter/components/ComboFiltersController';
import React, {FC} from 'react';
import {useListingContext} from 'plugins/modules/listing/context';
import {IProductShort} from 'modules/products/types';
import {SkeletonWrapper} from 'modules/skeleton/components/SkeletonWrapper';

export const ComboFilters: FC = () => {
    const {meta, isFetching} = useListingContext<IProductShort>();
    const comboFiltersList = meta?.combos;

    if (!comboFiltersList) {
        return null;
    }

    return (
        <SkeletonWrapper disabled={!isFetching}>
            <ComboFiltersController comboFiltersList={comboFiltersList} />
        </SkeletonWrapper>
    );
};
